// extracted by mini-css-extract-plugin
export default {"short":".2s","med":".6s","slow":"1s","timeDefault":".2s","easeIn":"cubic-bezier(.7,0,.84,0)","easeOut":"cubic-bezier(.16,1,.3,1)","easeInOut":"cubic-bezier(.87,0,.13,1)"};